import React, { useEffect, useState } from "react";
// import { HorizontalBar } from "react-chartjs-2";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from "../DashboardMain_Bus/WaterMark";
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice";

const HorizontalBarchart = ({ gloablfilter }) => {
  
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [net_consumption, setNetConsumption] = useState([]);
  const net_consumption_resp = (data_resp) => {
    setNetConsumption([{
      // "year": "Traction Sys.",
      "year": loggedInUser.flagForHideShow === "ERC" ? "Traction Sys." : "Trac. Sys.",
      "income": (data_resp[0]["Traction System"] !== undefined) ? Number((data_resp[0]["Traction System"].value).toFixed(2)) : 0,
      // "expenses": 18.1
    }, {
      "year": "HVAC",
      "income": (data_resp[0]["HVAC"] !== undefined) ? Number((data_resp[0]["HVAC"].value).toFixed(2)) : 0,
      // "expenses": 22.8
    }, {
      "year": "AUX-1",
      "income": (data_resp[0]["Aux-1"] !== undefined) ? Number((data_resp[0]["Aux-1"].value).toFixed(2)) : 0,
      // "expenses": 23.9
    }, {
      "year": "DC-DC",
      "income": (data_resp[0]["DC-DC"] !== undefined) ? Number((data_resp[0]["DC-DC"].value).toFixed(2)) : 0,
      // "expenses": 25.1
    }, {
      "year": "AUX-2",
      "income": (data_resp[0]["Aux-2"] !== undefined) ? Number((data_resp[0]["Aux-2"].value).toFixed(2)) : 0,
      // "expenses": 25
    }, {
      "year": "BCS-1",
      "income": (data_resp[0]["BCS-1"] !== undefined) ? Number((data_resp[0]["BCS-1"].value).toFixed(2)) : 0,
      // "expenses": 25
    }, {
      "year": "BCS-2",
      "income": (data_resp[0]["BCS-2"] !== undefined) ? Number((data_resp[0]["BCS-2"].value).toFixed(2)) : 0,
      // "expenses": 25
    }]);
  }

  const [dynamicBarColor, setDynamicBarColor] = useState("")
  useEffect(() => {
    (gloablfilter.VIN_NUM.length === 1) ? setDynamicBarColor("#3578b0") : setDynamicBarColor("#83A4CF")
    fetchData({ url: API_URL_MAIN + "energy_analysis_bus/consumption_fraction_and_factor", body: { filterdata: gloablfilter } }, net_consumption_resp)
  }, [gloablfilter])
  // Sample data
  // const data = {
  //   labels: [
  //     "Sunday",
  //     "Monday",
  //     "Tuesday",
  //     "Wednesday",
  //     "Thursday",
  //     "Friday",
  //     "Saturday",
  //   ],
  //   datasets: [
  //     {
  //       label: "Hours Studied in Geeksforgeeks",
  //       data: [2, 5, 7, 9, 7, 6, 4],
  //       fill: true,
  //       backgroundColor: "rgba(6, 156,51, .3)",
  //       borderColor: "#02b844",
  //     },
  //   ],
  // };

  useEffect(() => {
    if (net_consumption.length > 0) {
      /* Imports */

      /* Chart code */
      // Create root element
      // https://www.amcharts.com/docs/v5/getting-started/#Root_element
      let root = am5.Root.new("chartdiv1");

      // Set themes
      // https://www.amcharts.com/docs/v5/concepts/themes/
      root.setThemes([
        am5themes_Animated.new(root)
      ]);

      // Create chart
      // https://www.amcharts.com/docs/v5/charts/xy-chart/
      let chart = root.container.children.push(am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        // wheelX: "panX",
        // wheelY: "zoomX",
        paddingLeft: 0,
        layout: root.verticalLayout
      }));

      // Add legend
      // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
      // let legend = chart.children.push(am5.Legend.new(root, {
      //   centerX: am5.p50,
      //   x: am5.p50
      // }));

      let data = net_consumption
      // let data = [{
      //   "year": "Traction System",
      //   "income": 1207.13,
      //   // "expenses": 18.1
      // }, {
      //   "year": "HVAC",
      //   "income": 355.61,
      //   // "expenses": 22.8
      // }, {
      //   "year": "AUX-1",
      //   "income": 66.78,
      //   // "expenses": 23.9
      // }, {
      //   "year": "DC-DC",
      //   "income": 71.40,
      //   // "expenses": 25.1
      // }, {
      //   "year": "AUX-2",
      //   "income": 46.12,
      //   // "expenses": 25
      // }, {
      //   "year": "BCS-1",
      //   "income": 9.37,
      //   // "expenses": 25
      // }, {
      //   "year": "BCS-2",
      //   "income": 18.05,
      //   // "expenses": 25
      // }];

      // Create axes
      // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
      let yRenderer = am5xy.AxisRendererY.new(root, {
        cellStartLocation: 0,
        cellEndLocation: 1.2,
        minorGridEnabled: true,
        minGridDistance: 1,
        inversed: true
      });

      yRenderer.grid.template.set("location", 1);
      yRenderer.grid.template.set("visible", false);

      let yAxis = chart.yAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: "year",
          renderer: yRenderer,
          tooltip: am5.Tooltip.new(root, {}),
        })
      );

      yAxis.data.setAll(data);

      // let xRenderer = am5xy.AxisRendererX.new(root, {
      //   strokeOpacity: 0.1,
      //   minGridDistance: 50
      // });
      // xRenderer.grid.template.set("visible", false);
      // let xAxis = chart.xAxes.push(
      //   am5xy.ValueAxis.new(root, {
      //     min: 0,
      //     renderer: xRenderer
      //   })
      // );

      let xAxis = chart.xAxes.push(
        am5xy.ValueAxis.new(root, {
          min: 0,
          renderer: am5xy.AxisRendererX.new(root, {
            strokeOpacity: 0.1,
            minGridDistance: 70,
          })
        })
      );

      // Add column series
      // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
      let series1 = chart.series.push(am5xy.ColumnSeries.new(root, {
        name: "Income",
        xAxis: xAxis,
        yAxis: yAxis,
        valueXField: "income",
        categoryYField: "year",
        sequencedInterpolation: true,
        tooltip: am5.Tooltip.new(root, {
          pointerOrientation: "horizontal",
          labelText: "[bold]{name}[/]\n{categoryY}: {valueX}"
        }),
      }));

      series1.columns.template.setAll({
        height: am5.percent(70),
        // fill: am5.color("#83A4CF"),
        fill: am5.color(dynamicBarColor),
        // stroke: am5.color("#83A4CF")
        stroke: am5.color(dynamicBarColor)
      });

      if(loggedInUser.flagForHideShow !== "ERC"){
        series1.bullets.push(function () {
          return am5.Bullet.new(root, {
            locationX: 0,
            locationY: 0.5,
            sprite: am5.Label.new(root, {
              centerY: am5.p50,
              text: "[bold]{valueX}",
              populateText: true,
              fontSize: 12,
              // fill: am5.color(0xffffff),
              fill: am5.color('#03045E'),
            })
          });
        });
      }else{
        series1.bullets.push(function () {
          return am5.Bullet.new(root, {
            locationX: 1,
            locationY: 0.5,
            sprite: am5.Label.new(root, {
              centerY: am5.p50,
              text: "{valueX}",
              populateText: true,
              fontSize: 12
            })
          });
        });
      }

      // series1.bullets.push(function () {
      //   return am5.Bullet.new(root, {
      //     locationX: 1,
      //     locationY: 0.5,
      //     sprite: am5.Label.new(root, {
      //       centerX: am5.p100,
      //       centerY: am5.p50,
      //       text: "{name}" + "__",
      //       fill: am5.color(0xffffff),
      //       populateText: true
      //     })
      //   });
      // });

      // Add legend
      // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
      // legend.data.setAll(chart.series.values);

      // Add cursor
      // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
      // mouse click hover scroll
      // let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
      //   behavior: "zoomY"
      // }));
      // cursor.lineX.set("visible", false);
      // mouse click hover scroll

      series1.data.setAll(data);

      // Make stuff animate on load
      // https://www.amcharts.com/docs/v5/concepts/animations/
      series1.appear();
      chart.appear(1000, 100);
      root._logo.dispose();
      return () => root.dispose();
    }
  }, [net_consumption])

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <WaterMark />
      <div className="energyChartboxNew_Bus">
        <div className="v-title energyTitleChart_Bus pt-2 pb-2 text-center">
          <b className=''>Consumption Factor</b>
        </div>
        <div id='chartdiv1' style={{ width: "100%", height: "312px" }}></div>
      </div>
    </>
  );
};

export default HorizontalBarchart;
